var e = "10.28.0+unknown";
//#endregion
export { e as REPORT_PACKAGE_VERSION };
